import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Node, Edge } from '@xyflow/react'
import {
  nodes as initialNodes,
  edges as initialEdges
} from '~/components/flow-editor/initial-elements'
interface FlowState {
  nodes: Node[]
  edges: Edge[]
}
const initialState: FlowState = {
  nodes: initialNodes,
  edges: initialEdges
}
const flowSlice = createSlice({
  name: 'flow',
  initialState,
  reducers: {
    setNodes(state, action: PayloadAction<Node[]>) {
      state.nodes = action.payload
    },
    setEdges(state, action: PayloadAction<Edge[]>) {
      state.edges = action.payload
    }
  }
})
export const { setNodes, setEdges } = flowSlice.actions
export default flowSlice.reducer
